
export enum AssetUseType {
  OwnUse= 'OwnUse',
  ThirdPartRent= 'ThirdPartRent',
  Line= 'Line',

}